import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-izbor-prikaza',
  templateUrl: './izbor-prikaza.component.html',
  styleUrls: ['./izbor-prikaza.component.css']
})
export class IzborPrikazaComponent implements OnInit {
 
/*pet prikazov - brez preglednic */
id = [0, 1, 2, 3, 4];
/* vseh šest prikazov */
  /* id = [0, 1, 2, 3, 4, 5]; */

    izborPrikaza = [
        'Časovni poteki' ,
        'Srednje spremembe z zanesljivostjo',
        'Razponi sprememb',
        'Trendi z zanesljivostjo',
        'Povprečni razponi sprememb po regijah/postajah',
        'Preglednice'
    ];

    kratekOpisKartice = [
        'Časovni poteki sprememb do konca 21. stoletja, vključno z razponi odstopanj.' ,
        'Sprememba izbrane spremenljivke v danih projekcijskih obdobjih glede na obdobje 1981-2010 in pripadajoča zanesljivost spremembe za določen scenarij.',
        'Najmanjša vrednost, mediana in največja vrednost spremembe ansambla modelov v določenem obdobju za izbran scenarij glede na obdobje 1981-2010.',
        'Trendi izbrane spremenljivke s pripadajočo zanesljivostjo za določen scenarij v obdobju 1981-2100.',
        'Povprečni razponi sprememb izbrane spremenljivke po posameznih regijah po meteoroloških letnih časih in za celo leto za dane scenarije izpustov.',
        'Preglednica največje vrednosti, mediane in najmanjše vrednosti modelske spremembe meteorološke spremenljivke (v °C) v posamezni regiji po meteoroloških letnih časih in za celo leto od povprečja v obdobju 1981-2010.' 
    ];

    imenaPrilog = [
        'prikaz1.png',
        'prikaz2.png',
        'prikaz3.png',
        'prikaz4.png',
        'prikaz5.png',
        'prikaz6.png' 
    ];



  constructor(private router: Router,
              private route: ActivatedRoute) { }

  ngOnInit() {
  }

}
